import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MagezineDetail } from 'src/app/shared/interfaces/magezineDetail.interface';
import { environment } from 'src/environments/environment';
import { JwtService } from '../index.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinancialService {
  readonly BASE_URL = environment.BASE_API_URL;
  private balancedValueSubject$ = new Subject()
  private balancedValueObs$ = this.balancedValueSubject$.asObservable()
  constructor(
    private http:HttpClient,
    public jwtService:JwtService
  ) {}
  ngOnInit() {}
  setBalancedValue(balancedValue:any){
    this.balancedValueSubject$.next(balancedValue)
  }
  getBalancedValueObs(){
    return this.balancedValueObs$
  }
  chargeWallet(data:{amount:number,redirect_url:string}){
    return this.http.post<any>(this.BASE_URL+`wallet/pay/`, data)
  }
  getWallet(){
    return this.http.get<any>(this.BASE_URL+`wallet/`)
  }
  getTransactionList(){
    return this.http.get<any>(this.BASE_URL+`wallet/transaction/`)
  }
}
